export default "__VITE_ASSET__DVmz6sCp__"